$('body').on('click', '.file-uploader .select-file', function() {
    var uploader = $(this).parents('.file-uploader');
    uploader.find('input[type="file"]').trigger('click');
    return false;
});

function fileUploaderRemoveFile(uploader) {
	uploader.find('.meta p').html(uploader.find('.meta p').attr('data-default'));
    uploader.find('input[name="'+uploader.attr('data-file')+'"]').val('');
    uploader.find('.current-progress').css({
   		width: '0%'
	});
	uploader.find('.file').removeClass('has-file');
}

function fileUploaderAddFile(uploader, name, file) {
	uploader.removeClass('uploading');
    uploader.find('.file').addClass('has-file');
	uploader.find('.meta p').html(name);
    uploader.find('input[name="'+uploader.attr('data-file')+'"]').val(file);
    uploader.find('.current-progress').css({
   		width: '0%'
	});
}

$('body').on('click', '.file-uploader .remove-file', function() {
    var uploader = $(this).parents('.file-uploader');
    fileUploaderRemoveFile(uploader);
    return false;
});

$('body').on('change', '.file-uploader input[type="file"]', function() {
	var input = $(this);
	var uploader = input.parents('.file-uploader');
    var file = input[0].files[0];
    var payload = new FormData();

    payload.append('file', file);
    payload.append('_token', $('meta[name="csrf-token"]').attr('content'));

    uploader.find('.current-progress').css({
   		width: '0%'
	});
	uploader.find('.file').removeClass('has-file');
    uploader.addClass('uploading');
    $.ajax({
		xhr: function() {
	        var xhr = new window.XMLHttpRequest();
	        xhr.upload.addEventListener('progress', function(e) {
	            if (e.lengthComputable) {
	                var percentComplete = e.loaded / e.total;
	               	percentComplete = Math.round(percentComplete * 100);

	               	uploader.find('.current-progress').css({
	               		width: percentComplete+'%'
	               	});

	               	if(percentComplete === 100) {
	               		uploader.removeClass('uploading');
	               		uploader.find('.meta p').html('Processing File');
	               	}
	            }
	       }, false);
	       return xhr;
	    },
		type : 'POST',
		url : uploader.attr('data-url'),
		data : payload,
		dataType : 'json',
		processData: false,
        contentType: false,
		success : function(data) {
			console.log(data);

			if(!data.success) {
				uploader.find('.meta p').html('Error: '+data.message);
				return false;
			}

			fileUploaderAddFile(uploader, data.name, data.file);
		},
		error : function(request) {
			console.log(request.responseText);
		}
	});
    
    return false;
});